/** Creates a string of URL parameters from the given lineupParams object. */
export const createlineupParams = (lineupParams: { [key: string]: any }) => {
  return Object.entries(lineupParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')
}

export const getDropdownOptions = (data: any[]) => {
  for (let i = 0; i < data.length; i++) {
    data[i].text = data[i].name
    data[i].disabled = false
  }
  return data
}

export const getOptions = (category: any, data: any[]) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i].value == category) {
      data[i].selected = true
    } else {
      data[i].selected = false
    }
    data[i].text = data[i].name
    data[i].disabled = false
  }
  return data
}

export const getCheckboxOptions = (category: any, data: any) => {
  for (let i = 0; i < data.length; i++) {
    for (let j = 0; j < category.length; j++) {
      if (data[i].param == category[j]) {
        data[i].selected = true
      }
    }
  }
  return data
}
